import { Pipe, PipeTransform } from '@angular/core';
import { MultiLangStrDto } from '../../../models/multi-lang-str-dto';
import { map, Observable, of } from 'rxjs';
import { LanguageService } from 'src/app/services/language.service';

@Pipe({
    name: 'translateLang',
})
export class TranslateLangPipe implements PipeTransform {

    constructor(private languageService: LanguageService) { }

    transform(word: string | MultiLangStrDto): Observable<string> {
        if (!word) {
            return of('');
        }
        if (typeof word === 'string') {
            return of(word);
        }
        if ('hebrew' in word && 'english' in word) {
            return this.languageService.currentLanguage$.pipe(
                map((currentLang) => {
                    if (currentLang === 'he' && word.hebrew) {
                        return word.hebrew;
                    }

                    if (currentLang === 'en' && word.english) {
                        return word.english;
                    }
                    return currentLang === 'he' ? word.english : word.hebrew;
                })
            );
        }
        return of('');
    }
}
